import React, { useEffect, useRef } from 'react';
import { createChart } from 'lightweight-charts';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

function PortfolioChart({benchmarkData, portfolioData}) {
  const containerRef = useRef(null);
  const chartRef = useRef(null);
  
  useEffect(() => {
    if (!benchmarkData || benchmarkData.length === 0 ||!portfolioData || portfolioData.length === 0 || !containerRef.current) return;

    const chart = createChart(containerRef.current, {
      width: containerRef.current.clientWidth,
      height: containerRef.current.clientHeight - 20, //'800', //"300px", //chartContainerRef.current.clientHeight,
      // chart color options:   https://tradingview.github.io/lightweight-charts/tutorials/customization/chart-colors
      layout: {
        backgroundColor: "#000",
        textColor: "rgba(255, 255, 255, 0.9)",
      },
      grid: {
        vertLines: {
          color: "#334158",
        },
        horzLines: {
          color: "#334158",
        },
      },
      // crosshair: {
      //   mode: CrosshairMode.Normal,
      // },
      priceScale: {
        borderColor: "#485c7b",
      },
      timeScale: {
        borderColor: "#485c7b",
      },
      watermark: {
        visible: true,
        fontSize: 40,
        horzAlign: "center",
        vertAlign: "center",
        color: " rgba(255, 165, 0, 0.1)",
        text: "Anahit",
      },
    });

    chartRef.current = chart;

    const formattedPortfolioData = []
    const formattedBenchmarkData = []
    
    const parsedPortfolioData = JSON.parse(portfolioData);
    const parsedBenchmarkData = JSON.parse(benchmarkData);
    //console.log(typeof parsedData)
    for (const [timeString, value] of Object.entries(parsedBenchmarkData)) {
        // const datePart = time.substring(0, 10);
        // formattedData.push({ time: datePart, value }); // Modify to use 'time' instead of 'datePart'
        const date = new Date(timeString); // Parse the date string into a Date object
        const formattedDateString = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
        formattedBenchmarkData.push({ time: formattedDateString, value });
    }
        
    //console.log(typeof parsedData)
    for (const [timeString, value] of Object.entries(parsedPortfolioData)) {
        // const datePart = time.substring(0, 10);
        // formattedData.push({ time: datePart, value }); // Modify to use 'time' instead of 'datePart'
        const date = new Date(timeString); // Parse the date string into a Date object
        const formattedDateString = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
        formattedPortfolioData.push({ time: formattedDateString, value });
    }
    // console.log("printing formatted data")
    // console.log(formattedBenchmarkData)
    const lineSeriesBenchmark = chartRef.current.addLineSeries({  color:'#8A9A5B' }); // Set color for the first line series
    const lineSeriesPortfolio = chartRef.current.addLineSeries({ color: '#FF0000' }); // Set color for the second line series

    lineSeriesBenchmark.setData(formattedBenchmarkData);
    lineSeriesPortfolio.setData(formattedPortfolioData);

    return () => {
      if (chartRef.current !== null) {
        chartRef.current.remove();
      }
    };
  }, [benchmarkData, portfolioData]);

        return <Box
        id="chart-id"
        ref={containerRef}
        className="chart-container"
        sx={{ height: "65vh", position: "relative",border: "1px solid #000" }}
        >
          </Box>
          ;
}

export default PortfolioChart;


